
export default {
  name: 'Redirect',
  data() {
    return {
      isRedirecting: false,
      redirectUrl: null,
      isInIframe: false,
    }
  },
  mounted() {
    this.initRedirect()
  },
  methods: {
    initRedirect() {
      // URL'i query'den al
      const url = this.$route.query.url || this.$route.query.src
      
      if (!url) {
        return
      }

      // URL'i decode et
      try {
        this.redirectUrl = decodeURIComponent(url)
      } catch (e) {
        this.redirectUrl = url
      }

      // Iframe kontrolü
      this.isInIframe = window.self !== window.top

      // Yönlendirme işlemini başlat
      this.startRedirect()
    },
    startRedirect() {
      this.isRedirecting = true

      // Iframe içindeyse postMessage gönder
      if (this.isInIframe) {
        try {
          window.parent.postMessage(
            {
              type: 'redirect',
              url: this.redirectUrl,
            },
            '*' // Güvenlik için production'da spesifik origin belirtilebilir
          )
        } catch (e) {
          console.error('PostMessage hatası:', e)
        }
      }

      // 500ms sonra yönlendir
      setTimeout(() => {
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl
        }
      }, 500)
    },
  },
  head() {
    return {
      title: this.$custom$t('redirect.title') || 'Yönlendiriliyor',
      meta: [
        {
          name: 'description',
          content: this.$custom$t('redirect.description') || 'Yönlendiriliyor',
        },
        { name: 'robots', content: 'noindex, nofollow' },
      ],
    }
  },
}
